import { JSX } from 'react';

export const logInsert = {
	cutout: ({ x = -10.5, y = -13.5, opacity = 1 }: {x?: number; y?: number; opacity?: number;}): JSX.Element => {
		return <g fill="white" stroke="none" strokeWidth="0.125" transform={`translate(${x}, ${y})`} opacity={opacity}>
			<path d="
				M 0 27
				L 0 5
				A 10.5 5 0 0 1 21 5
				L 21 27
				"
			/>
			<line x1="3" y1="0" x2="18" y2="0" stroke="black"/>
		</g>;
	}
};
